import { useRef, useEffect, Suspense, useState } from 'react';
import { Canvas, useFrame, useLoader } from '@react-three/fiber';
import { OrbitControls, useTexture } from '@react-three/drei';
import { PLYLoader } from 'three-stdlib';

const LucyModel = () => {
  const [url, setUrl] = useState('/models/Lucy100k.ply');
  const geometry = useLoader(PLYLoader, url);

  useEffect(() => {
    geometry.computeVertexNormals();
    geometry.scale(0.0024, 0.0024, 0.0024);
  }, [geometry]);

  // Force reload on remount
  useEffect(() => {
    setUrl('/models/Lucy100k.ply?' + Math.random());
  }, []);

  return (
    <mesh
      geometry={geometry}
      position={[0, 0.8, 0]}
      rotation={[0, -Math.PI / 2, 0]}
      castShadow
      receiveShadow
      dispose={null}
    >
      <meshStandardMaterial color={0x1e3825} dispose={null} />
    </mesh>
  );
};

const AnimatedSpotlight = () => {
  const light = useRef();
  useFrame(({ clock }) => {
    const t = clock.getElapsedTime() / 3;
    if (light.current) {
      light.current.position.x = Math.cos(t) * 2.5;
      light.current.position.z = Math.sin(t) * 2.5;
      light.current.target.position.set(0, 0.8, 0);
    }
  });
  return (
    <spotLight
      ref={light}
      position={[2.5, 5, 2.5]}
      angle={Math.PI / 6}
      penumbra={1}
      decay={2}
      distance={0}
      intensity={6}
      castShadow
      shadow-mapSize-width={1024}
      shadow-mapSize-height={1024}
      shadow-camera-near={1}
      shadow-camera-far={10}
      color={0xd5f5e3}
    />
  );
};

const Ground = () => {
  const tex = useTexture('/textures/marmol2.png');
  return (
    <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0, -1, 0]}>
      <planeGeometry args={[9, 9]} />
      <meshStandardMaterial map={tex} color={0x787878} />
    </mesh>
  );
};

export const SpotlightThree = () => {
  return (
    <div
      style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 0 }}
    >
      <Canvas
        shadows
        camera={{ position: [7, 4, 1], fov: 40, near: 0.1, far: 100 }}
      >
        <Suspense fallback={null}>
          <ambientLight intensity={0.15} />
          <AnimatedSpotlight />
          <Ground />
          <LucyModel />
        </Suspense>
        <OrbitControls
          minDistance={2}
          maxDistance={10}
          maxPolarAngle={Math.PI / 2}
          target={[0, 1, 0]}
        />
      </Canvas>
    </div>
  );
};
